export const clearSensitiveLoginUrl = () => {
  if (typeof window === "undefined" || !window.history?.replaceState) {
    return;
  }

  window.history.replaceState(
    window.history.state,
    document.title,
    window.location.pathname
  );
};
